import React, { useEffect } from 'react';
import RegisterService from '@Services/Register';
import RegisterComponent from './Register';

function RegisterContainer(props) {
  useEffect(() => {
    const fetchData = async () => {
      const data = await RegisterService.getData();
      if (data.bulkId && data.bulkPassword) {
        // setHasAccess(true);
        Promise.resolve();
      } else {
        // history.push(paths.ACCESS_DENIED); // Redirect to an access denied page
      }
    };

    fetchData();
  }, []);
  // FR-1.3: render `RegisterComponent` (which renders `<Page>` → `.react-page`) directly, with no
  // wrapping element. On this public route `.react-page` must be a direct flex child of `#root` so
  // it stretches/shrinks to the viewport and its `overflow-y: auto` produces the scroll. A wrapper
  // `<div>` here (overflow:visible, min-height:auto) grows to content as `#root`'s flex child, which
  // stops `.react-page`'s `height:100%` from clamping and kills scrolling on tall content.
  return <RegisterComponent {...props} />;
}

export default RegisterContainer;
